module.exports = __webpack_public_path__ + "img/word.b2fa4516.png";